<template>
  <BgImageLayout title="RESEARCH OUTPUT">
    <div class="wrapper">
      <q-card id="tabs-container" flat class="no-padding fit">
        <q-card-section id="tabs-content" class="no-padding">
          <q-tabs align="center">
            <q-route-tab v-for="tab of tabs" :key="tab.id" :to="tab.route" :ripple="false">
              {{ tab.name }}
            </q-route-tab>
          </q-tabs>

          <keep-alive>
            <router-view />
          </keep-alive>
        </q-card-section>
      </q-card>
    </div>
  </BgImageLayout>
</template>

<script>
export default {
  data: () => ({
    selectedMember: 1,
    tabs: [
      {
        id: 1,
        name: 'Validate',
        route: '/research-output/validate'
      },
      {
        id: 2,
        name: 'Upload',
        route: '/research-output/upload'
      },
      {
        id: 3,
        name: 'Admin',
        route: '/research-output/admin'
      },
      {
        id: 4,
        name: 'Analysis',
        route: '/research-output/analysis'
      }
    ]
  })
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/mixins'

tabStyle()

.wrapper {
  background-color #E6E6E6
  color black
  height calc(100vh - 85px)

  > section {
    display grid
    grid-auto-flow column
    justify-content space-between
    gap 10px
    background-color white
    padding 10px
  }
}

#tabs-content {
  height 100%
  display grid
  grid-template-rows auto 1fr

  .q-tabs {
    margin-top -30px

    .q-tab--inactive {
      color white
      opacity 1
      font-weight 400
    }
  }
}
</style>
